module.exports = __webpack_public_path__ + "img/icon-17.4e78a7b0.png";